var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPowerBt48Line = function SvgIconPowerBt48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 38.8c-3.95 0-7.67-1.54-10.46-4.33-2.8-2.79-4.33-6.51-4.33-10.46 0-3.95 1.54-7.67 4.33-10.46l2.54 2.54a11.119 11.119 0 0 0-3.28 7.92c0 2.99 1.17 5.8 3.28 7.92 4.37 4.37 11.47 4.37 15.84 0 2.12-2.12 3.28-4.93 3.28-7.92s-1.17-5.8-3.28-7.92l2.54-2.54c2.8 2.79 4.33 6.51 4.33 10.46 0 3.95-1.54 7.67-4.33 10.46-2.79 2.8-6.51 4.33-10.46 4.33Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8 9h-3.6v16h3.6V9Z",
    fill: "current"
  })));
};
export default SvgIconPowerBt48Line;